import React from 'react'
import { type ModalComponentProps } from 'modals'

import { Text } from 'components/dataDisplay'
import { PlainModal } from 'components/feedback'

import s from './CommonDrawerModal.scss'


const CommonDrawerModal: React.CFC<ModalComponentProps & CommonDrawerModal.Props> = (props) => {
  const {
    children,
    title, text,
    overlayClosable,
    closeModal,
    'data-testid': dataTestId,
  } = props

  return (
    <PlainModal
      className={s.modal}
      closeModal={closeModal}
      overlayClosable={overlayClosable}
      data-testid={dataTestId}
    >
      <Text className="pr-48" message={title} style="sh5" html />
      {
        Boolean(text) && (
          <Text className="mt-16" message={text} style="p2" html />
        )
      }
      {children}
    </PlainModal>
  )
}


export default CommonDrawerModal
